import searchSuccessCallbackFactory from './search-success-callback-factory';
import sampleOptenPartner from "./opten-sample";

const MIN_SEARCH_TEXT_LENGTH = 3;
const VALID_LENGTH = 5;

function optenSearchController(SearchService, PartnerService, QueryParamService, $q, $timeout, $filter, EndPointProtection) {
	EndPointProtection.registerEndpointParams('optenSearch', 60, 15);
	var ctrl = this;

	ctrl.$filter = $filter;

	var searchSuccessCallback = searchSuccessCallbackFactory(ctrl);
	ctrl.$onInit = function () {
		ctrl.searchTextTimeout = null;
		ctrl.suggestedPartners = [];
		ctrl.searchLoading = false;
		ctrl.searchText = '';
		ctrl.forCompanyLabel = ctrl.forCompany && ctrl.forCompany === true ? $filter('translator')('opten_input_enterprise') : $filter('translator')('opten_input_individual');
	};

	ctrl.isEbizPartner = function (item) {
		return item.ebizPartner;
	};

	ctrl.setAddressLine = function (item) {
		let addressLine;
		try {
			if (item.content.Party.PostalAddress.Country.IdentificationCode !== 'HU') {
				addressLine = item.content.Party.PostalAddress.Country.IdentificationCode + ', ' +
					item.content.Party.PostalAddress.PostalZone + ' ' +
					item.content.Party.PostalAddress.CityName + ', ' +
					item.content.Party.PostalAddress.AddressLine.Line;
			} else {
				addressLine = item.AddressLine;
			}
		} catch (error) {
			angular.noop(error);
			addressLine = '';
		}
		return addressLine;
	};

	ctrl.tagging = function (elementName) {
		if (angular.isDefined(ctrl.taggingFunction)) {
			ctrl.taggingFunction({elementName: elementName});
		}
	};

	ctrl.onSelect = function (item, searchText) {
		if (item && item.notOpten) {
			ctrl.companyModel = {name: searchText};
		}

		if (angular.isDefined(ctrl.onSelectFunction)) {
			var calleParams = {
				item: item,
				searchText: searchText
			};

			if (ctrl.invoiceProperty) {
				calleParams.additionalParams = ctrl.invoiceProperty;
			}

			if(!item.opten) {
				PartnerService.getPartnerPrimaryContact(item)
					.then((email) => {
						calleParams.item.primaryContactEmail = email;
					})
					.finally(() => {
						ctrl.onSelectFunction(calleParams);
					});
			} else {
				ctrl.onSelectFunction(calleParams);
			}

		}
	};

	ctrl.search = function (searchText) {

		EndPointProtection.registerEndpointUsage('optenSearch');

		ctrl.searchLoading = true;
		ctrl.suggestedPartners = [];

		if (!searchText || searchText.length < MIN_SEARCH_TEXT_LENGTH) {
			if (ctrl.form && ctrl.form.uiSelectedFirm) {
				ctrl.form.uiSelectedFirm.$setValidity('minlength', false);
			}
			ctrl.searchLoading = false;
			return;
		} else {
			if (ctrl.form && ctrl.form.uiSelectedFirm) {
				ctrl.form.uiSelectedFirm.$setValidity('minlength', true);
			}
		}

		// Java oldalra kerul Pomeisl
		// const SEARCH_TEXT = optenLetterFilter(searchText);

		if (angular.isDefined(ctrl.searchFunction)) {
			ctrl.searchFunction(searchText);
		} else if (ctrl.form.uiSelectedFirm.$valid) {
			SearchService.optenSearch(searchText, ctrl.optenOnly)
				.then(searchSuccessCallback)
				.catch(error => {
					if (error.status === 429) {
						ctrl.tooMuchRequest = true;
					}
					if (error.status === 404 && ctrl.addEmptyLastElement) {
						sampleOptenPartner.showName = $filter('translator')('opten_notFound');
						sampleOptenPartner.Name = $filter('translator')('opten_notFound');
						sampleOptenPartner.name = $filter('translator')('opten_notFound');
						ctrl.suggestedPartners.push(sampleOptenPartner);
					}
					ctrl.searchLoading = false;
				});
		}
	};

	$(document).on('cancelSavePartner', function () {
		ctrl.companyModel = null;
		ctrl.form.$setPristine();
		ctrl.form.$setUntouched();
	});

}

export default optenSearchController;
